import React from 'react';

var Geolocation = function Geolocation(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "Geolocation"), /*#__PURE__*/React.createElement("path", {
    d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm6.93-4.002a7.007 7.007 0 0 1-5.442 5.844c.008.051.012.104.012.158v2a1 1 0 0 1-2 0v-2-.018a7.003 7.003 0 0 1-6.43-5.984A1.015 1.015 0 0 1 5 13H3a1 1 0 0 1 0-2h2c.024 0 .047 0 .07.002a7.004 7.004 0 0 1 5.932-5.931A1.015 1.015 0 0 1 11 5V3a1 1 0 0 1 2 0v2c0 .024 0 .047-.002.07a7.004 7.004 0 0 1 5.931 5.932L19 11h2a1 1 0 0 1 0 2h-2c-.024 0-.047 0-.07-.002zM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    fill: "currentColor"
  }));
};

Geolocation.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
import iconHandler from './hoc';
export { Geolocation as icon };
export default iconHandler(Geolocation);